// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"72ad42ed","453":"ad6eb26e","551":"5758ca26","627":"c1de36c9","653":"0988f3c5","867":"9f2d5160","923":"b65eab56"}[chunkId] + ".chunk.js";
};